// src/views/proveedores/productos/EliminarProductoProveedor.js
import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { eliminarProductoProveedor } from '../../../actions/proveedores';

const EliminarProductoProveedor = ({ producto, reestablecerProducto }) => {
    const dispatch = useDispatch();

    const [eliminarModal, setEliminarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const handleCerrar = () => {
        if (!statusProcesar) {
            setEliminarModal(false);
            reestablecerProducto(null);
        }
    };

    const handleProcesar = async () => {
        if (!producto?._id) return;

        await setStatusProcesar(true);

        await dispatch(eliminarProductoProveedor(producto._id));

        await setStatusProcesar(false);
        await handleCerrar();
    };

    useEffect(() => {
        if (producto) {
            setEliminarModal(true);
        }
    }, [producto]);

    return (
        <Modal show={eliminarModal} backdrop="static" centered onHide={handleCerrar}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar producto</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    ¿Deseas eliminar el producto "{producto?.nombre}" de este proveedor?
                </p>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-danger mr-3"
                    onClick={handleCerrar}
                    disabled={statusProcesar}
                >
                    <i className="fas fa-times fa-sm"></i> No
                </button>

                {statusProcesar ? (
                    <button type="button" className="btn btn-success" disabled>
                        <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                        ></span>{' '}
                        Si
                    </button>
                ) : (
                    <button
                        type="button"
                        className="btn btn-success"
                        onClick={handleProcesar}
                    >
                        <i className="fas fa-check fa-sm"></i> Si
                    </button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default EliminarProductoProveedor;
